import React from 'react';

import PropTypes from 'prop-types';
import {compose, graphql} from 'react-apollo';
import {requireLoggedUser} from 'helpers/login';
import {withOperator} from 'helpers/operator';

import {FormattedMessage} from "react-intl";

import Loading from "components/Loading";
import PrerecordedMessages from './PrerecordedMessages';

import {logGraphqlError} from "helpers/errors";

import PrerecordedMessageQuery from 'gql/prerecordedMessages/prerecordedMessages.gql';
import PrerecordedMessageChangeMutation from 'gql/prerecordedMessages/prerecordedMessageChange.gql';

class PrerecordedMessagesProvider extends React.Component {
    static propTypes = {
        prerecordedMessageQuery: PropTypes.object.isRequired,
        prerecordedMessageChangeMutation: PropTypes.func.isRequired,
        operator: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        onLogout: PropTypes.func.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
    };

    componentWillMount() {
        this.setState({
            formProcessing: false
        });
    }

    onFormSubmit(model) {
        this.setState({
            formProcessing: true
        });

        const mutations = [];
        Object.keys(model).forEach((fieldName) => {
            mutations.push(this.props.prerecordedMessageChangeMutation({
                variables: {
                    prerecordedMessageId: fieldName,
                    active: model[fieldName]
                }
            }));
        });

        Promise.all(mutations).then(() => {
            this.setState({
                formProcessing: false,
                formStatus: {
                    type: 'success',
                    message: <FormattedMessage id="prerecorded_messages.form.success" default="Prerecorded messages' settings were successfully saved"/>
                }
            });
        }).catch((error) => {
            logGraphqlError(error);

            this.setState({
                formProcessing: false,
                formStatus: {
                    type: 'danger',
                    message: <FormattedMessage id="prerecorded_messages.form.failure" default="Prerecorded messages' settings could not be saved"/>
                }
            });
        });
    }

    render() {
        const {prerecordedMessageQuery, operator, onLogout, onOnlineChange} = this.props;
        const {formStatus} = this.state;

        if (prerecordedMessageQuery.loading) {
            return <Loading/>
        }

        let prerecordedMessages = [];
        if (prerecordedMessageQuery.prerecordedMessages) {
            prerecordedMessages = prerecordedMessageQuery.prerecordedMessages;
        }

        return <PrerecordedMessages prerecordedMessages={prerecordedMessages} operator={operator}
                                    onLogout={onLogout} onOnlineChange={onOnlineChange}
                                    formStatus={formStatus} formProcessing={this.state.formProcessing} onFormSubmit={::this.onFormSubmit}/>
    }
}

export default compose(
    requireLoggedUser,
    withOperator,
    graphql(PrerecordedMessageQuery, {
        name: 'prerecordedMessageQuery',
        options: props => ({
            variables: {
                operator: props.user.id
            },
            fetchPolicy: 'network-only'
        })
    }),
    graphql(PrerecordedMessageChangeMutation, {
        name: 'prerecordedMessageChangeMutation'
    })
)(PrerecordedMessagesProvider);


// WEBPACK FOOTER //
// ./src/containers/PrerecordedMessages/index.jsx